module.exports = __webpack_public_path__ + "static/media/IMG-4.179298aa.jpg";